import {
  Component,
  HostBinding,
  input,
  output,
  ViewChild,
} from '@angular/core';
import { QaiIconButtonComponent, QaiLinkButtonComponent } from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';
import { PracticeCallDetailsModalComponent } from '../modal/practice-call-details-modal/practice-call-details-modal.component';
import { ICallDetailModal } from 'src/app/interfaces/icall-detail-modal';

@Component({
  imports: [QaiIconButtonComponent, QaiLinkButtonComponent, TranslocoModule, PracticeCallDetailsModalComponent],
  selector: 'app-pathway-call-header',
  standalone: true,
  styleUrls: ['./call-header.scss'],
  templateUrl: './call-header.html',
})
export class PathwayCallHeaderComponent {
  @ViewChild(PracticeCallDetailsModalComponent) private callDetailsModal!: PracticeCallDetailsModalComponent;

  title = input.required<string>();
  isLoading = input(false);
  showCallDetails = input<boolean>(false);
  callDetails = input<ICallDetailModal | null>(null);

  settingsClicked = output<void>();
  leaveStepClicked = output<void>();
  callDetailsModalOpened = output<void>();
  callDetailsModalClosed = output<void>();

  protected handleViewCallDetailsClick(): void {
    this.callDetailsModal.open();
  }

  protected handleSettingsClick() {
    this.settingsClicked.emit();
  }

  protected handleLeaveStepClick() {
    this.leaveStepClicked.emit();
  }

  @HostBinding('class')
  protected get cssClass() {
    return {
      isLoading: !!this.isLoading(),
    };
  }
}
